export default {
  global: {
    steps: {
      state_done: "Schritt abgeschlossen",
      state_progress: "Schritt in Prüfung",
      state_error: "Schritt abgelehnt",
      state_current: "Aktueller Schritt",
      state_upcoming: "Kommender Schritt",
    },
    tabs: {
      error: "Einige Felder in diesem Tab enthalten Fehler, bitte überprüfen Sie diese",
    },
    selected_count: ({ plural, named }) => plural([`${named("count")} ausgewählt`, `${named("count")} ausgewählt`]),
    select_all_label: "Alle auswählen: {name}",
    select_none_label: "Alle abwählen: {name}",
    list: {
      title: "Liste der {name}",
    },
    view: {
      title: ({ plural, named }) => plural([`Daten von ${named("name")}`, `Daten eines/einer ${named("name")}`]),
    },
    add: {
      title: ({ plural, named }) => plural([`${named("name")} hinzufügen`, `${named("name")} hinzufügen`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich hinzugefügt!`, `${named("name")} erfolgreich hinzugefügt!`]),
    },
    accept: {
      title: ({ plural, named }) => plural([`${named("name")} akzeptieren`, `${named("name")} akzeptieren`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich akzeptiert!`, `${named("name")} erfolgreich akzeptiert!`]),
    },
    decline: {
      title: ({ plural, named }) => plural([`${named("name")} ablehnen`, `${named("name")} ablehnen`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich abgelehnt!`, `${named("name")} erfolgreich abgelehnt!`]),
    },
    edit: {
      title: ({ plural, named }) =>
        plural([`${named("name")} bearbeiten`, `${named("name")} bearbeiten`, `${named("name")} bearbeiten`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich bearbeitet!`, `${named("name")} erfolgreich bearbeitet!`]),
    },
    active: {
      title: ({ plural, named }) =>
        plural([`${named("name")} aktivieren`, `${named("name")} aktivieren`, `${named("name")} aktivieren`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie ${named("name")} wirklich aktivieren?`,
          `Möchten Sie ${named("name")} wirklich aktivieren?`,
          `Möchten Sie ${named("name")} wirklich aktivieren?`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich aktiviert!`, `${named("name")} erfolgreich aktiviert!`]),
    },
    unactive: {
      title: ({ plural, named }) =>
        plural([`${named("name")} deaktivieren`, `${named("name")} deaktivieren`, `${named("name")} deaktivieren`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie ${named("name")} wirklich deaktivieren?`,
          `Möchten Sie ${named("name")} wirklich deaktivieren?`,
          `Möchten Sie ${named("name")} wirklich deaktivieren?`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich deaktiviert!`, `${named("name")} erfolgreich deaktiviert!`]),
    },
    regenerate: {
      errors: "Fehler beim Neu-Generieren",
      title: ({ plural, named }) => plural([`${named("name")} neu generieren`, `${named("name")} neu generieren`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich neu generiert!`, `${named("name")} erfolgreich neu generiert!`]),
    },
    import: {
      errors: "Ihre Datei enthält Fehler. Bitte korrigieren Sie diese und starten Sie den Import erneut",
      title: "Importieren von {name}",
      error: "Fehler Zeile {line} Spalte {column}:",
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich importiert!`, `${named("name")} erfolgreich importiert!`]),
    },
    ypareo: {
      title: "Letzte Synchronisation am: {date}",
      title_failure: "Synchronisation fehlgeschlagen. Letzter Versuch am: {date}",
    },
    export: {
      title: "{name} exportieren",
      title_singular: "{name} exportieren",
      title_alone: "Exportieren",
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich exportiert!`, `${named("name")} erfolgreich exportiert!`]),
    },
    update: {
      title: "Ihre {name} ergänzen",
      success: "{name} erfolgreich ergänzt!",
    },
    search: {
      title: "{name} suchen",
      reset_filters: "Filter zurücksetzen",
      active_filters: "Aktive Filter",
      remove_filter: "Filter {name} entfernen",
    },
    sort: {
      success: "Reihenfolge der {name} erfolgreich aktualisiert!",
    },
    download: {
      success: "{name} erfolgreich heruntergeladen!",
      title: "{name} herunterladen",
      done: "Download abgeschlossen",
      error: "Beim Herunterladen ist ein Fehler aufgetreten",
    },
    move: {
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich verschoben!`, `${named("name")} erfolgreich verschoben!`]),
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} erfolgreich dupliziert!`, `${named("name")} erfolgreich dupliziert!`]),
      title: ({ plural, named }) =>
        plural([`Dieses/n ${named("name")} duplizieren`, `Dieses/n ${named("name")} duplizieren`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie dieses/n ${named("name")} wirklich duplizieren?`,
          `Möchten Sie dieses/n ${named("name")} wirklich duplizieren?`,
        ]),
    },
    empty: {
      title: ({ plural, named }) =>
        plural([
          `Es gibt noch kein/e ${named("name1")} in diesem/r ${named("name2")}. Klicken Sie auf '+', um eines/eine hinzuzufügen`,
          `Es gibt noch kein/e ${named("name1")} in diesem/r ${named("name2")}. Klicken Sie auf '+', um eines/eine hinzuzufügen`,
          `Es gibt noch kein/e ${named("name1")} in diesem/r ${named("name2")}. Klicken Sie auf '+', um eines/eine hinzuzufügen`,
        ]),
      dashboard: "Es gibt noch kein/e {name}",
      no_data_available: "Keine Daten verfügbar",
      no_data_entered: "Es wurden noch keine Daten erfasst, bitte fügen Sie einen Eintrag hinzu.",
    },
    delete: {
      title_alone: "Löschen",
      title: ({ plural, named }) =>
        plural([`${named("name")} löschen`, `${named("name")} löschen`, `${named("name")} löschen`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Möchten Sie ${named("name")} wirklich löschen?`,
          `Möchten Sie ${named("name")} wirklich löschen?`,
          `Möchten Sie ${named("name")} wirklich löschen?`,
        ]),
      success: ({ plural, named }) =>
        plural([
          `${named("name")} erfolgreich gelöscht!`,
          `${named("name")} erfolgreich gelöscht!`,
          `${named("name")} erfolgreich gelöscht!`,
          `${named("name")} erfolgreich gelöscht!`,
        ]),
    },
    valid: {
      title: ({ plural, named }) =>
        plural([`${named("name")} validieren`, `${named("name")} validieren`, `${named("name")} validieren`]),
    },
    unvalid: {
      title: ({ plural, named }) =>
        plural([
          `${named("name")} ungültig machen`,
          `${named("name")} ungültig machen`,
          `${named("name")} ungültig machen`,
        ]),
    },
    opened: {
      title: ({ plural }) => plural(["Geöffnet", "Geöffnet", "Geöffnet", "Geöffnet"]),
    },
    closed: {
      title: ({ plural }) => plural(["Geschlossen", "Geschlossen", "Geschlossen", "Geschlossen"]),
    },

    label: {
      name: "Name",
      date: "Datum",
      triads: "Trinômes",
      trainings: "Ausbildungen",
    },
    actions: {
      title: "Aktionen",
      empty: "Derzeit sind keine Aktionen verfügbar",
    },
    see_more: "Mehr anzeigen...",
    see_less: "Weniger anzeigen...",
    see_detail: "Details anzeigen/ausblenden",
    collapse_show: "Anzeigen",
    collapse_reduce: "Reduzieren",
    close: "Schließen",
    duration: "Dauer",
    period: "Zeitraum",
    show_hide_actions: "Aktionen anzeigen / ausblenden",
    show_hide_caption: "Legende anzeigen / ausblenden",
    visible: "Sichtbar",
    visible_by: "Sichtbar für",
    hidden: "Unsichtbar",
    required: "Erforderlich",
    send: "Senden",
    send_mail: "E-Mail senden",
    send_opco: "An OPCO übermitteln",
    valid_file: "Akte validieren",
    language: {
      change: "Sprache ändern ({language})",
      french: "Französisch",
      english: "Englisch",
      spanish: "Spanisch",
      german: "Deutsch",
    },
    stats: "Statistiken",
    setting: "Konfiguration",
    module: "Module",
    control: "Steuerung",
    badge_new: "Neu",
    light: "Hell",
    dark: "Dunkel",
    caption: {
      title: "Legende",
    },
    home_alert: {
      title: "Information",
      do_not_show_agin: "Diese Meldung nicht mehr anzeigen",
    },
    entity: {
      contact: {
        title: ({ plural }) => plural(["Kontakt", "Kontakte"]),
      },
    },
    menu: {
      studea_manager_area: "Gruppensteuerung",
      admin_area: "Administratorbereich",
    },
    total: "Gesamt",
    totalCompany: "Gesamtbetrag zu Lasten des Arbeitgebers (Pflichtbeitrag + Restbetrag)",
    table: {
      filtered_result: ({ plural }) => plural(["gefiltertes Ergebnis", "gefilterte Ergebnisse"]),
    },
    other: ({ plural }) => plural(["Sonstiges", "Sonstiges"]),
    data_table: {
      filtered_result: ({ plural, named }) =>
        plural([`(${named("count")} gefiltertes Ergebnis)`, `(${named("count")} gefilterte Ergebnisse)`]),
      filter_active: "(Filter aktiv)",
      select_all: "Alle auswählen",
      page_selected: ({ plural, named }) =>
        plural([
          `Die Zeile dieser Seite ist ausgewählt.`,
          `Alle ${named("count")} Zeilen dieser Seite sind ausgewählt.`,
        ]),
      select_all_results: ({ named }) => `Alle ${named("total")} Ergebnisse auswählen`,
      all_results_selected: ({ plural, named }) =>
        plural([`Das Ergebnis ist ausgewählt.`, `Alle ${named("total")} Ergebnisse sind ausgewählt.`]),
      select_line: "Zeile auswählen",
      year: ({ named }) => `Jahr ${named("year")}`,
      person_type: {
        prospect: "Interessent",
        candidate: "Kandidat",
        prospect_initial: "I",
        candidate_initial: "K",
      },
      person_icon: {
        phone: "Möchte zurückgerufen werden",
      },
    },
    grouped_table: {
      count: ({ plural, named }) => plural([`${named("count")} Element`, `${named("count")} Elemente`]),
      count_filtered: ({ named }) => `${named("visible")} von ${named("total")} Elementen`,
      filter: "Filtern",
      search: "Suchen",
      status: {
        success: "Erfolg",
        warning: "Warnung",
        danger: "Gefahr",
      },
      trend: {
        title: "Trend",
      },
    },
    user: {
      activate: {
        success: "Benutzer erfolgreich aktiviert!",
      },
    },
    expand: "Ausklappen",
    collapse: "Einklappen",
    drag_to_reorder: "Zum Neuanordnen ziehen",
    move_with_arrows: "„{title}“ mit den Pfeiltasten nach oben und unten verschieben",
    comments: "Kommentare",
    support: "Zum STUDEA-Support",
    new_window: "(öffnet in neuem Fenster)",
    historic: {
      title: "Verlauf",
    },
    aria_label_separator: " — ",
  },
  breadcrumb: {
    home: "Startseite",
  },
  loading: "Wird geladen",
};
